import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import utils from './slices/utils';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

const rootReducer = combineReducers({
  toggleDropdown: utils.toggleDropdown,
  modalActions: utils.modalActions,
  wallets: utils.wallets,
  rolesAndPermissions: utils.rolesAndPermissions,
  usdRequests: utils.usdRequests,
  usdHeldRequests: utils.usdHeldRequests,
  usdRequestsScrollUtils: utils.usdRequestScrollUtils,
  usdRequestsMetrics: utils.usdRequestsMetrics,
  failedVerifications: utils.failedVerifications,
});

const persistConfig = {
  key: 'piggyvest-admin',
  storage,
  whitelist: ['failedVerifications'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
